import React, { useState } from 'react';

import CommonModal from '..';
import { LoginContent, LoginModalProps } from './LoginContent';

export async function loginModalShow(options: LoginModalProps) {
  return new Promise<boolean>((resolve) => {
    CommonModal.show((t) => ({
      width: '400px',
      footer: false,
      requireLogin: false, // 登录弹窗本身不需要登录验证，避免死循环
      customPadding: {
        x: 32,
        y: 32,
      },
      modalClassName: 'login-modal',
      content: (close) => (
        <LoginContent
          {...options}
          onClose={() => {
            close();
            resolve(false);
            options.onClose?.();
          }}
          onSuccess={() => {
            close();
            resolve(true);

            // 触发全局登录成功事件，通知其他组件更新登录状态
            window.dispatchEvent(new Event('userLoginSuccess'));

            options.onSuccess?.();
          }}
        />
      ),
    }));
  });
}

export { LoginContent };
